import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

import ProtectedLayout from "./components/auth/ProtectedLayout";

import Index from "./pages/Dashboard/index";

import OpenPositions from "./pages/Dashboard/OpenPositions";
import ExistingPositions from "./pages/Dashboard/ExistingPositions";
import Database from "./pages/Dashboard/Database";
import JdPreview from "./pages/Dashboard/JdPreview";
import StackRanking from "./pages/Analysis/StackRanking";
import StackRankingMain from "./pages/Analysis/StackRankingMain";
import ResumeFormatter from "./pages/Dashboard/ResumeFormatter";
import CandidateEngagement from "./pages/CandidateEngagement";
import AnalyticsDashboard from "./pages/Dashboard/AnalyticsDashboard";
import AuthCallback from "./pages/Auth/AuthCallback";
import SetPassword from "./pages/Auth/SetPassword";
import AdminPanel from "./pages/Admin/AdminPanel";
import UnauthorizedPage from "./pages/Auth/UnauthorizedPage";
import CrossAppWizetokBridge from "./pages/Auth/CrossAppWizetokBridge";

function AppContent() {
  return (
    <div className="App">
      <Routes>
        {/* Public entry + SSO login — no loading gate; session check is silent on Index */}
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<Index />} />
        <Route path="/credentials-login" element={<Navigate to="/login" replace />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        {/* Cross-app: ReachOut session → Wizetok handoff (no login prompt when already signed in) */}
        <Route path="/sso/wizetok" element={<CrossAppWizetokBridge />} />

        {/* Public: shown when access is denied (no valid session needed) */}
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        {/* Protected app: auth gate runs before navbar or any child page renders */}
        <Route element={<ProtectedLayout />}>
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/open-positions" element={<OpenPositions />} />
          <Route path="/existing-positions" element={<ExistingPositions />} />
          <Route path="/database" element={<Database />} />
          <Route path="/database/:positionId" element={<Database />} />
          <Route path="/jd-preview/:positionId" element={<JdPreview />} />
          <Route path="/stack-ranking" element={<StackRankingMain />} />
          <Route path="/stack-ranking/:positionId" element={<StackRanking />} />
          <Route path="/resume-formatter" element={<ResumeFormatter />} />
          <Route path="/engagement" element={<CandidateEngagement />} />
          <Route path="/candidates" element={<CandidateEngagement />} />
          <Route path="/open-wizetok" element={null} />
          <Route path="/whatsapp-reachout" element={<Navigate to="/engagement" replace />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Route>

        {/* Catch-all: any unknown URL (e.g. /landing, /dashboard) goes to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        style={{ zIndex: 20000 }}
        limit={3}
        hideProgressBar={false}
        newestOnTop
      />
    </div>
  );
}

// Apply saved theme to <html> immediately on page load (before React renders)
try {
  const saved = localStorage.getItem('hirecrux-theme') || 'light';
  document.documentElement.setAttribute('data-theme', saved);
} catch {}

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppContent />
    </Router>
  );
}

export default App;
